import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService, UrlParam } from './classes/BaseService';

@Injectable()
export class CountryPollService extends BaseService {

  apiUrl = 'country-poll/';

  constructor(protected http: HttpClient) {
    super(http);
  }

  getCountries() {
    return this.get(this.serverUrl + this.apiUrl + 'countries.php');
  }

  getResults() {
    return this.get(this.serverUrl + this.apiUrl + 'results.php');
  }

  vote(countryCode: string, clientId: string) {
    const url = this.serverUrl + this.apiUrl + 'vote.php';
    return this.post(url, this.buildUrlParams(
      new UrlParam('countryCode', countryCode),
      new UrlParam('clientId', clientId)
    ));
  }

}
